const notificationsBoxToggle = () => {

    const localStorageKey = 'unreadOnlyNotificationsToggle';


    $('#unread-only-notifications-toggle').click(function () {
        if ($(this).is(':checked')){
            localStorage.setItem(localStorageKey,'checked');

            $('.c-notifications__item--read-message').hide();
            if ($('.c-notifications__item--unread-message').length === 0) {
                $('#c-box-notifications-up-to-date').show();
            } else {
                $('#c-box-notifications-up-to-date').hide();
            }
        } else {
            localStorage.setItem(localStorageKey,'notChecked');

            $('.c-notifications__item--read-message').show();
            $('#c-box-notifications-up-to-date').hide();
        }
    });


    const unreadOnlyNotificationsToggle = localStorage.getItem(localStorageKey);

    if (unreadOnlyNotificationsToggle === 'checked') {
        $('#unread-only-notifications-toggle').prop('checked', true);

        $('.c-notifications__item--read-message').hide();
        if ($('.c-notifications__item--unread-message').length === 0) {
            $('#c-box-notifications-up-to-date').show();
        } else {
            $('#c-box-notifications-up-to-date').hide();
        }
    }


};



export const notificationsBox = () => {
    notificationsBoxToggle();
};


